import { type ProductLineItemAction, ProductLineItemActionType, type ProductLineItemState } from './types';

export const productLineItemReducer = (
  state: ProductLineItemState,
  action: ProductLineItemAction,
): ProductLineItemState => {
  switch (action.type) {
    case ProductLineItemActionType.SET_LINE_ITEM_QUANTITY:
      return {
        ...state,
        lineItemQuantity: action.value,
      };
    case ProductLineItemActionType.ADJUST_LINE_ITEM_QUANTITY:
      return {
        ...state,
        lineItemQuantity: state.lineItemQuantity + action.value,
      };
    case ProductLineItemActionType.SET_IS_SKU_CAP_REACHED:
      return {
        ...state,
        isSkuCapReached: action.isSkuCapReached,
      };
    case ProductLineItemActionType.SET_ADJUSTED_QUANTITY:
      return {
        ...state,
        adjustedQuantity: action.adjustedQuantity,
      };
    case ProductLineItemActionType.SET_HAS_VALIDATED:
      return {
        ...state,
        hasValidated: action.hasValidated,
      };
    case ProductLineItemActionType.SET_HAS_GENERIC_ERROR:
      return {
        ...state,
        hasGenericError: action.hasGenericError,
      };
    default:
      return state;
  }
};
